<template>
  <div class="wrap-nav-about">
    <div class="box-nav">
      <b-container>
        <nav>
          <b-row align-h="center">
            <div v-for="(menu, i) in menusx" :key="i" cols="6" md="3" lg="auto" class="link"
              :class="[isLoaded && menu.isActive ? 'active' : '']" @click.prevent="selectContent(menu.keyName)">
              <b-col v-if="menu.isDisplay">
                <div>
                  <img :src="require(`../../assets/icons/${menu.icon}`)" />
                  <span>{{ menu.title }}</span>
                </div>
              </b-col>
            </div>
          </b-row>
        </nav>
      </b-container>
    </div>

    <b-container>
      <template v-for="(menu, index) in menusx">
        <component :key="index" v-if="menu.isActive && isLoaded" :is="menu.componentName" />
      </template>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { constantsComputed } from '@/store/helpers'
const AdmanHistory = () => import('./AdmanHistory')
const CommitteeMembers = () => import('./CommitteeMembers')
const ChairmanBiography = () => import('./ChairmanBiography')
const MessageFromChairman = () => import('./MessageFromChairman')
const WorkingCommitteeMembers = () => import('./WorkingCommitteeMembers')

export default {
  components: {
    AdmanHistory,
    CommitteeMembers,
    WorkingCommitteeMembers,
    ChairmanBiography,
    MessageFromChairman
  },

  data () {
    return {
      isLoaded: false,
      menus: [
        {
          title: 'Adman History',
          icon: 'icon-chat.png',
          isActive: true,
          isDisplay: true,
          componentName: 'AdmanHistory',
          tabName: 'admanhistory',
          keyName: 'admanhistory'
        },
        {
          title: 'Management Committee',
          icon: 'icon-element-about.png',
          isActive: false,
          isDisplay: true,
          componentName: 'CommitteeMembers',
          tabName: 'managementcommittee',
          keyName: 'managementcommittee'
        },
        {
          title: 'Working Committee',
          icon: 'icon-element-about.png',
          isActive: false,
          isDisplay: true,
          componentName: 'WorkingCommitteeMembers',
          tabName: 'workingcommittee',
          keyName: 'workingcommittee'
        },
        {
          title: 'IMPACT',
          icon: 'icon-users-chat.png',
          isActive: false,
          isDisplay: false,
          componentName: 'ChairmanBiography',
          tabName: 'impact',
          keyName: 'conceptDynamic'
        },
        {
          title: 'Message From Chairwoman',
          icon: 'icon-light-left.png',
          isActive: false,
          isDisplay: false,
          componentName: 'MessageFromChairman',
          tabName: 'message-from',
          keyName: 'message-from'
        }
      ]
    }
  },

  watch: {
    $route () {
      this.processNav()
    }
  },

  created () {
    setTimeout(() => {
      this.processNav()
    }, 600)

    if (!this.workingcommitteeDuration) {
      this.$store.dispatch('about/getWorkingCommitteeDuration')
    }

    setTimeout(() => {
      this.checkMenuWorkingCommittee()
    }, 800)
  },

  computed: {
    ...constantsComputed,
    ...mapState({
      workingcommitteeDuration: state => state.about.workingcommitteeDuration
    }),

    menusx () {
      return this.menus
        .map(menu => {
          const mConfig = this.configMap.get(menu.keyName)

          if (!mConfig) {
            return menu
          }

          return {
            ...menu,
            title: mConfig.name,
            tabName: mConfig.tabName,
            isDisplay: mConfig.isDisplay
          }
        })
        .filter(menu => menu.isDisplay)
    }

  },

  methods: {
    processNav () {
      this.isLoaded = false
      this.menus = this.menusx

      const { tab } = this.$route.query
      const tabs = this.menusx.map(m => m.tabName)

      if (tabs.includes(tab)) {
        this.menus.forEach((menu, i) => {
          this.menus[i].isActive = false
        })
        const menu = this.menus.find(m => m.tabName === tab)
        menu.isActive = true
      }
      this.isLoaded = true
    },

    selectContent (keyName) {
      let tab = ''

      this.menus = this.menusx

      this.menusx.forEach((menu, i) => {
        if (keyName === menu.keyName) {
          this.menus[i].isActive = true
          tab = menu.tabName
        } else {
          this.menus[i].isActive = false
        }
      })

      this.$router
        .push({
          path: this.$route.fullPath,
          query: { tab: tab }
        })
        .catch(() => { })
    },

    checkMenuWorkingCommittee () {
      this.menus[2].isDisplay = Boolean(this.workingcommitteeDuration)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables.scss";

.wrap-nav-about {
  .box-nav {
    background-color: $light;

    .container {
      nav {
        .row {
          .link {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 62px;
            cursor: pointer;

            div {
              display: flex;
              justify-content: center;
              align-items: center;

              img {
                height: 22px;
              }

              span {
                margin-left: 8px;
                font-size: 1.25rem;
                line-height: 0.8;
                font-family: var(--button-default-font-family, "DB Adman X");

                @media only screen and (min-width: $break-l) {
                  font-size: 1.5rem;
                }
              }
            }
          }

          .active {
            border-bottom: 3px solid $active;

            div {
              padding-top: 3px;
            }
          }
        }
      }
    }
  }
}
</style>
